module.exports = __webpack_public_path__ + "static/media/Rucha Datar.3c20f454.png";